/** @jsxImportSource @emotion/react */
import { SerializedStyles, css } from "@emotion/react";
import {
  LinkText,
  LinkTextItem,
  LinkTextStyleType,
} from "components/atoms/LinkText/LinkText";
import { SlashLineSeparator } from "components/atoms/SlashSeparator/SlashLineSeparator";
import React from "react";
import { mixin } from "styles/mixin";
import { defaultTheme } from "styles/theme";

export type LinkTextsProps = {
  items: LinkTextItem[];
  separator?: React.ReactNode;
  cssOverride?: SerializedStyles;
  styleType?: LinkTextStyleType;
};

export const LinkTexts: React.FC<LinkTextsProps> = ({
  items,
  separator = <SlashLineSeparator mx={defaultTheme.spacing.xxxs} />,
  cssOverride,
  styleType,
}: LinkTextsProps) => {
  return (
    <p
      css={[
        cssOverride,
        css`
          ${mixin.text.note};
          display: flex;
          align-items: center;
          flex-wrap: wrap;
        `,
      ]}
    >
      {items.map((item, index) => (
        <React.Fragment key={index}>
          <LinkText item={item} styleType={styleType} />
          {index !== items.length - 1 && (
            <React.Fragment>{separator}</React.Fragment>
          )}
        </React.Fragment>
      ))}
    </p>
  );
};
